import React, { Fragment } from "react";
import { useToggle } from "@sportal/cdk/hooks";
import { useTooltipPosition } from "@sportal/cdk/tooltip";

import { CreateRuleButton } from "../createRuleButton/CreateRuleButton";
import { RulePopup } from "../rulePopup/RulePopup";

const a11yScheduleAddedTranslation = "aria_draft_schedule_added";

export const CreateSchedulePopover = ({
  updateStatusInfo,
  disabled,
  addSchedule,
  schedules,
  type,
  profile,
}) => {
  const [showPopup, togglePopup] = useToggle(false);
  const {
    setReferenceElement,
    setPopperElement,
    setArrowElement,
    styles,
    attributes,
  } = useTooltipPosition("bottom", [
    { name: "offset", options: { offset: [12, 12] } },
    {
      name: "flip",
      options: { fallbackPlacements: ["top", "right", "left"] },
    },
  ]);

  const handlePopupToggle = () => {
    togglePopup();
    showPopup && updateStatusInfo("");
  };

  return (
    <Fragment>
      <CreateRuleButton
        disabled={disabled}
        onClick={handlePopupToggle}
        ref={setReferenceElement}
      />
      {showPopup && (
        <RulePopup
          setPopperElement={setPopperElement}
          setArrowElement={setArrowElement}
          popperStyles={styles}
          attributes={attributes}
          togglePopup={handlePopupToggle}
          useShortNotations={false}
          addSchedule={(schedule) => {
            addSchedule(schedule);
            updateStatusInfo(a11yScheduleAddedTranslation);
          }}
          schedules={schedules}
          type={type}
          profile={profile}
        />
      )}
    </Fragment>
  );
};
